/**
 * FormRow - Horizontal row of form fields with consistent spacing
 *
 * Used for laying out multiple related inputs side-by-side
 */

import React from 'react';
import { Box } from '@mui/material';

/**
 * FormRow Component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Field elements
 * @param {number} [props.spacing=2] - Gap between items (MUI spacing units)
 * @param {boolean} [props.wrap=true] - Allow wrapping on small screens
 * @param {string} [props.align='flex-start'] - Vertical alignment
 * @param {Object} [props.sx={}] - Additional MUI sx styles
 *
 * @example
 * <FormRow spacing={2}>
 *   <NumberInput label="Quantity" value={qty} onChange={setQty} />
 *   <NumberInput label="Daily Miles" value={miles} onChange={setMiles} />
 * </FormRow>
 */
export function FormRow({
    children,
    spacing = 2,
    wrap = true,
    align = 'flex-start',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: spacing,
                flexWrap: wrap ? 'wrap' : 'nowrap',
                alignItems: align,
                mb: 2,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}

export default FormRow;
